import "./ContactUsModal.less";

import React, { Component } from "react";
import { translate } from "react-i18next";

class ContactUsModal extends Component {
	render() {
		const t = this.props.t;

		return (
			<div className="modal fade" id="contactmodal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								{t("title")}
							</h5>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="container-fluid">
								<div className="row">
									<div className="col-md-8 map">
										<div className="mapouter">
											<div className="gmap_canvas">
												<iframe
													title="Google maps"
													height="400"
													id="gmap_canvas"
													src={`https://maps.google.com/maps?${t("address.googleMapUrlQuery")}`}
													frameBorder="0"
													scrolling="no"
													marginHeight="0"
													marginWidth="0"
												/>
												<a href="https://www.embedgooglemap.net">embedgooglemap.net</a>
											</div>
										</div>
									</div>
									<div className="col-md-4 address">
										<h2>Plantyn nv</h2>
										<p>
											<span style={{ fontWeight: "bold" }}>{t("address.prefix")}</span> {t("address.content")}
										</p>
										<p>
											<span style={{ fontWeight: "bold" }}>{t("tel.prefix")}</span> {t("tel.content")}
										</p>
										<p>
											<span style={{ fontWeight: "bold" }}>E-mail:</span> helpdesk@plantyn.com
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<h2>{t("needHelp.title")}</h2>
							<p>
								{t("needHelp.text")} <a href={t("needHelp.link")}>helpdesk.plantyn.com</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const translateContactUsModal = translate("contact")(ContactUsModal);

export { translateContactUsModal as ContactUsModal };



// WEBPACK FOOTER //
// ./src/components/Modals/ContactUsModal/ContactUsModal.js